import { Modal } from 'react-bootstrap'
import React, { useState, useEffect } from 'react'
import Affiliate from '../../templates/Affiliate/Affiliate'
import Loading from '../../templates/UI/Loading/Loading'
import CampaignSearch from '../CampaignSearch/CampaignSearch'
import callAPI from '../../helpers/callAPI'

export default function AffiliateTestCallbackModal({ show, hide, affiliate, showSystemMessage }) {
    const [campaign, setCampaign] = useState({ id: 0, name: '' })
    const [rates, setRates] = useState([])
    const [campaignTracking, setCampaignTracking] = useState(false)
    const [advertiserTracking, setAdvertiserTracking] = useState(false)
    const [callbacks, setCallbacks] = useState([])
    const [globalCallback, setGlobalCallback] = useState({ type: '', code: '' })
    const [selectedRate, setSelectedRate] = useState(false)
    const [subid1, setSubid1] = useState('')
    const [subid2, setSubid2] = useState('')
    const [subid3, setSubid3] = useState('')
    const [subid4, setSubid4] = useState('')
    const [subid5, setSubid5] = useState('')
    const [saleAmount, setSaleAmount] = useState(0)

    useEffect(async () => {
        if (campaign.id > 0) {
            // Fetch the rates
            const result = await callAPI(`campaign/${campaign.id}`, 'GET')

            if (result['success'] === true) {
                setRates(result.campaign.rates)
                setCampaignTracking(result.campaign.tracking)
                setAdvertiserTracking(result.campaign.advertiser.tracking)
            } else if (result['success'] === false) {
                console.log('Error fetching campaign rates.')
            } else {
                console.log('Error fetching campaign rates.')
            }
        }

        if (affiliate && affiliate.id > 0) {
            const callbackResult = await callAPI(`affiliate/${affiliate.id}/callbacks`, 'GET')

            if (callbackResult['success'] === true) {
                setCallbacks(callbackResult.callbacks)
            } else if (callbackResult['success'] === false) {
                console.log('Error fetching affiliate callbacks.')
            } else {
                console.log('Error fetching affiliate callbacks.')
            }

            const affiliateResult = await callAPI(`affiliate/${affiliate.id}`, 'GET')
            if (affiliateResult['success'] === true) {
                setGlobalCallback(affiliateResult.affiliate.tracking.global_callback)
            } else if (affiliateResult['success'] === false) {
                console.log('Error fetching affiliate global callback.')
            } else {
                console.log('Error fetching affiliate global callback.')
            }
        }
    }, [campaign, affiliate])

    const getCallback = (campaignTracking, advertiserTracking, callbacks, globalCallback) => {
        
        if (campaignTracking && advertiserTracking && callbacks && globalCallback) {
            let callbackType = false
            let callbackCode = false

            let campaignSpecificCallback = callbacks.findIndex((callback) => callback.id === campaign.id && (callback.callback.type === 'L' || callback.callback.type === 'S'))

            if (campaignTracking.type.value === 'S' || campaignTracking.type.value === 'G' || campaignTracking.type.value === 'A') {
                if (campaignSpecificCallback >= 0) {
                    // We have a campaign specific callback.
                    if (callbacks[campaignSpecificCallback].callback.type === 'S' || (callbacks[campaignSpecificCallback].callback.type === 'L' && !advertiserTracking.merchant_supports_multiple_postbacks)) {
                        callbackType = 'Campaign Specific'
                        callbackCode = callbacks[campaignSpecificCallback].callback.code
                    }
                } else {
                    // Check if there is a global callback.
                    if (globalCallback.type === 'S' || (globalCallback.type === 'L' && !advertiserTracking.merchant_supports_multiple_postbacks)) {
                        callbackType = 'Global'
                        callbackCode = globalCallback.code
                    }
                }
            } else {
                // Tracking is not server, global or API, we can ONLY use server callbacks
                if (campaignSpecificCallback >= 0) {
                    if (callbacks[campaignSpecificCallback].callback.type === 'S') {
                        callbackType = 'Campaign Specific'
                        callbackCode = callbacks[campaignSpecificCallback].callback.code
                    }
                } else {
                    if (globalCallback.type === 'S') {
                        callbackType = 'Global'
                        callbackCode = globalCallback.code
                    }   
                }                
                
            }           

            if (callbackType && callbackCode) {
                return (
                    <div>
                        <hr></hr>
                        <div>Callback for this lead: ({callbackType}):</div>
                        <div className="alert alert-secondary mt-2">{callbackCode}</div>
                    </div>
                )
            } else {
                return (
                    <div>
                        <hr></hr>                                                
                        {(campaignTracking.type.value === 'S' || campaignTracking.type.value === 'G' || campaignTracking.type.value === 'A') &&
                            campaignSpecificCallback >= 0 ?
                                (callbacks[campaignSpecificCallback].callback.type === 'L' && advertiserTracking.merchant_supports_multiple_postbacks) ?
                                    <div className="alert alert-secondary mt-2">Switch the affiliate's campaign postback type to SERVER.</div>
                                :
                                    <div>No callback set.</div>
                            :
                                (globalCallback.type === 'L' && advertiserTracking.merchant_supports_multiple_postbacks) ?
                                    <div className="alert alert-secondary mt-2">Switch the affiliate's global postback type to SERVER.</div>
                                :
                                    <div>No callback set.</div>
                        }
                    </div>
                )
            }
        }
    }

    const submitTest = async (e) => {
        e.preventDefault()

        console.log(campaign, affiliate, selectedRate)

        if (campaign && affiliate && selectedRate) {
            let postBody = {
                affiliate_id: affiliate.id,
                rate_name: selectedRate.rate_name,
                offer_type: selectedRate.rate_type,
                leads: 1,
                confirmLeads: 1,
                sale_amount: selectedRate.rate_type === 'P' || selectedRate.rate_type === 'M' ? saleAmount : 0,
                subid1: subid1,
                subid2: subid2,
                subid3: subid3,
                subid4: subid4,
                subid5: subid5,
                lead_data: 'LEAD_TEST'                
            }

            let result = await callAPI(`campaign/${campaign.id}/addLeads`, 'POST', postBody)

            if (result) {
                if (result.success) {
                    showSystemMessage('success', 'Lead created.')
                } else {
                    showSystemMessage('error', result.errors.message)
                }
            } else {
                showSystemMessage('error', 'Failed to create lead.')
            }

            hide()
        } else {
            showSystemMessage('error', 'You must select a campaign and a rate.')
        }
    }

    const handleRate = (rates, ratename) => {
        let foundRate = rates.filter( rate => rate.rate_name === ratename )
        setSelectedRate(foundRate[0])
    }

    return (
        <Modal show={show} onHide={() => hide()} size={'lg'}>
            {affiliate ? (
                <>
                    <Modal.Header closeButton>
                        <div className="mb-h1-dark">
                            Test a lead and callback for: <Affiliate aid={affiliate.id} name={affiliate.name} priority={affiliate.priority.value} status={affiliate.status.value} />
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="alert alert-info font-weight-bold">Note: This feature only works for SERVER tracked campaigns.</div>
                        <div className="form-group form-inline">                            
                            <div className="text-left w-25">Campaign: </div>
                            <div className="w-50">
                                <CampaignSearch campaign={campaign} setCampaign={setCampaign} />
                            </div>
                        </div>

                        {campaign.id > 0 && (
                            <div>
                                <form>
                                    <div className="form-group form-inline">
                                        <div className="text-left w-25">Rate: </div>
                                        <div className="w-50">
                                            <select className="form-control" required onChange={(e)=>{handleRate(rates, e.target.value)}}>
                                                <option value=""></option>
                                                {rates.map((rate) => {
                                                    return (
                                                        <option key={rate.rate_name} value={`${rate.rate_name}`}>
                                                            {rate.rate_name} ({rate.affiliate_rate_text} / {rate.network_rate_text})
                                                        </option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    {selectedRate && (selectedRate.rate_type === 'M' || selectedRate.rate_type === 'P') && (
                                        <div className="form-group form-inline">
                                            <div className="text-left w-25">Sale Amount </div>
                                            <div className="w-50">
                                                <input type="text" className="form-control" onChange={(e) => setSaleAmount(e.target.value)}></input>
                                            </div>
                                        </div>
                                    )}
                                    <div className="form-group form-inline">
                                        <div className="text-left w-25">Subid 1: </div>
                                        <div className="w-50">
                                            <input type="text" className="form-control" onChange={(e) => setSubid1(e.target.value)}></input>
                                        </div>
                                    </div>
                                    <div className="form-group form-inline">
                                        <div className="text-left w-25">Subid 2: </div>
                                        <div className="w-50">
                                            <input type="text" className="form-control" onChange={(e) => setSubid2(e.target.value)}></input>
                                        </div>
                                    </div>
                                    <div className="form-group form-inline">
                                        <div className="text-left w-25">Subid 3: </div>
                                        <div className="w-50">
                                            <input type="text" className="form-control" onChange={(e) => setSubid3(e.target.value)}></input>
                                        </div>
                                    </div>
                                    <div className="form-group form-inline">
                                        <div className="text-left w-25">Subid 4: </div>
                                        <div className="w-50">
                                            <input type="text" className="form-control" onChange={(e) => setSubid4(e.target.value)}></input>
                                        </div>
                                    </div>
                                    <div className="form-group form-inline">
                                        <div className="text-left w-25">Subid 5: </div>
                                        <div className="w-50">
                                            <input type="text" className="form-control" onChange={(e) => setSubid5(e.target.value)}></input>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <button className="btn btn-primary" onClick={(e) => submitTest(e)}>
                                            Create Lead
                                        </button>
                                    </div>
                                </form>
                                {getCallback(campaignTracking, advertiserTracking, callbacks, globalCallback)}
                            </div>
                        )}
                    </Modal.Body>
                </>
            ) : (
                <Loading />
            )}
        </Modal>
    )
}
